(function () {
  if (window.SimpleBundlesSwatchesLoaded) return;
  window.SimpleBundlesSwatchesLoaded = true;

  var PLACEHOLDER_TEXT = 'please select an option';
  var productCache = {};

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/[''`""\u2018\u2019\u201c\u201d]/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseMaybeJson(value) {
    if (typeof value !== 'string') return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  function collectOptionLeaves(value, inheritedName, leaves) {
    var parsedValue = parseMaybeJson(value);

    if (Array.isArray(parsedValue)) {
      parsedValue.forEach(function (item) {
        collectOptionLeaves(item, inheritedName, leaves);
      });
      return;
    }

    if (parsedValue && typeof parsedValue === 'object') {
      var directValue =
        parsedValue.value !== undefined
          ? parsedValue.value
          : parsedValue.optionValue;
      var directName =
        parsedValue.name ||
        parsedValue.optionName ||
        inheritedName;

      if (directValue !== undefined) {
        collectOptionLeaves(directValue, directName, leaves);
        return;
      }

      Object.keys(parsedValue).forEach(function (key) {
        collectOptionLeaves(parsedValue[key], key, leaves);
      });
      return;
    }

    var normalizedValue = normalize(parsedValue);
    if (!normalizedValue || normalizedValue === '[object object]') return;

    leaves.push({
      name: normalize(inheritedName),
      value: normalizedValue,
    });
  }

  function getBundledVariantImage(bundledVariant) {
    var candidates = [
      bundledVariant.featured_image,
      bundledVariant.featuredImage,
      bundledVariant.product_image,
      bundledVariant.productImage,
      bundledVariant.image,
      bundledVariant.featured_media,
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = parseMaybeJson(candidates[index]);

      if (typeof candidate === 'string' && candidate) return candidate;
      if (!candidate || typeof candidate !== 'object') continue;

      var imageUrl =
        candidate.src ||
        candidate.url ||
        candidate.preview_image?.src ||
        candidate.previewImage?.src;
      if (imageUrl) return imageUrl;
    }

    return '';
  }

  function parseShadeColors(value) {
    var colors = {};

    String(value || '')
      .split(/\r?\n/)
      .forEach(function (line) {
        var separator = line.indexOf(':');
        if (separator < 1) return;

        var name = normalize(line.slice(0, separator));
        var color = line.slice(separator + 1).trim();
        if (name && color) colors[name] = color;
      });

    return colors;
  }

  function getCurrentVariantId(controller) {
    var variantInput = controller.form?.querySelector('[name="id"]');
    return variantInput ? String(variantInput.value) : '';
  }

  function getCurrentVariantData(controller) {
    return controller.config.variants[getCurrentVariantId(controller)] || {};
  }

  function buildProductMap(controller) {
    var variantData = getCurrentVariantData(controller);
    var bundledVariants = parseMaybeJson(variantData.bundledVariants) || [];
    var map = {};

    if (!Array.isArray(bundledVariants)) return map;

    bundledVariants.forEach(function (bundledVariant) {
      var variantOptions = parseMaybeJson(bundledVariant.variant_options) || [];
      var optionLeaves = [];
      var record = {
        handle: bundledVariant.handle || '',
        variantId:
          bundledVariant.variant_id ||
          bundledVariant.variantId ||
          bundledVariant.id ||
          null,
        image: getBundledVariantImage(bundledVariant),
      };

      collectOptionLeaves(variantOptions, '', optionLeaves);

      optionLeaves.forEach(function (optionLeaf) {
        map[optionLeaf.value] = record;
        if (optionLeaf.name) {
          map[optionLeaf.name + '::' + optionLeaf.value] = record;
        }
      });
    });

    return map;
  }

  function fetchProduct(record, country) {
    if (!record?.handle) return Promise.resolve(null);

    var key = record.handle + ':' + country;
    if (productCache[key]) return productCache[key];

    var root = window.Shopify?.routes?.root || '/';
    var url = new URL(
      root + 'products/' + encodeURIComponent(record.handle) + '.js',
      window.location.origin
    );
    if (country) url.searchParams.set('country', country);

    var currentParams = new URLSearchParams(window.location.search);
    ['preview_theme_id', 'pb', '_fd'].forEach(function (key) {
      if (currentParams.has(key)) {
        url.searchParams.set(key, currentParams.get(key));
      }
    });

    if (
      window.Shopify?.designMode &&
      window.Shopify?.theme?.id &&
      !url.searchParams.has('preview_theme_id')
    ) {
      url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    }

    productCache[key] = fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load bundle product');
        return response.json();
      })
      .catch(function () {
        return null;
      });

    return productCache[key];
  }

  function getVariant(product, record) {
    if (!product || !Array.isArray(product.variants)) return null;

    if (record?.variantId) {
      var exactVariant = product.variants.find(function (variant) {
        return String(variant.id) === String(record.variantId);
      });
      if (exactVariant) return exactVariant;
    }

    return product.variants.length === 1 ? product.variants[0] : null;
  }

  function getProductImage(product, record) {
    var variant = getVariant(product, record);
    return (
      variant?.featured_image?.src ||
      variant?.featured_image ||
      product?.featured_image ||
      record?.image ||
      ''
    );
  }

  function getProductAvailability(product, record) {
    var variant = getVariant(product, record);
    if (variant) return variant.available !== false;
    return product ? product.available !== false : true;
  }

  function findAppSelects(controller) {
    return Array.prototype.filter.call(controller.section.querySelectorAll('select'), function (select) {
      if (select.closest('[data-sb-io]')) return false;

      return Array.prototype.some.call(select.options || [], function (option) {
        return normalize(option.textContent) === PLACEHOLDER_TEXT;
      });
    });
  }

  function hideAppSelectors(controller) {
    var appSelects = findAppSelects(controller);

    appSelects.forEach(function (select) {
      select.classList.add('sb-io-app-selector--hidden');

      var appBlock = select.closest('.shopify-app-block, [id^="shopify-block-"]');
      if (appBlock) appBlock.classList.add('sb-io-app-selector--hidden');
    });

    controller.appSelects = appSelects;
    return appSelects;
  }

  function syncAppSelect(controller, group, value) {
    var index = Number(group.dataset.optionIndex);
    var select = controller.appSelects?.[index];
    if (!select) return;

    var matchingOption = Array.prototype.find.call(select.options || [], function (option) {
      return normalize(option.textContent) === normalize(value);
    });

    if (!matchingOption || matchingOption.disabled) return;

    select.value = matchingOption.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateBundleSelection(controller) {
    var values = [];

    controller.gate.querySelectorAll('[data-sb-io-prop]').forEach(function (input) {
      if (input.value) values.push(input.value);
    });

    if (controller.bundleSelectionInput) {
      controller.bundleSelectionInput.value = values.join(' <> ');
    }
  }

  function isMalformedProperty(value) {
    if (typeof value !== 'string') return false;

    var trimmedValue = value.trim();
    if (trimmedValue.toLowerCase() === '[object object]') return true;
    if (!/^[{[]/.test(trimmedValue)) return false;

    var parsedValue = parseMaybeJson(trimmedValue);
    return Boolean(parsedValue && typeof parsedValue === 'object');
  }

  function sanitizeMalformedPropertyControls(controller) {
    controller.form
      ?.querySelectorAll('[name^="properties["]')
      .forEach(function (control) {
        if (!isMalformedProperty(control.value)) return;

        control.disabled = true;
        control.dataset.sbIoMalformedProperty = 'true';
      });
  }

  function sanitizeMalformedFormData(event) {
    var formData = event.formData;
    if (!formData) return;

    var entries = Array.from(formData.entries());
    entries.forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];
      var propertyMatch = key.match(/^properties\[(.*)\]$/);
      if (!propertyMatch || !/[\[\]]/.test(propertyMatch[1])) return;

      var safePropertyName = propertyMatch[1].replace(/[\[\]]/g, '').trim();
      formData.delete(key);

      if (!safePropertyName || isMalformedProperty(value)) return;

      var safeKey = 'properties[' + safePropertyName + ']';
      if (!formData.has(safeKey)) {
        formData.append(safeKey, value);
      }
    });

    entries = Array.from(formData.entries());
    var malformedKeys = new Set();

    entries.forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];

      if (key.indexOf('properties[') === 0 && isMalformedProperty(value)) {
        malformedKeys.add(key);
      }
    });

    malformedKeys.forEach(function (key) {
      var validValues = entries
        .filter(function (entry) {
          return entry[0] === key && !isMalformedProperty(entry[1]);
        })
        .map(function (entry) {
          return entry[1];
        });

      formData.delete(key);
      validValues.forEach(function (value) {
        formData.append(key, value);
      });
    });
  }

  function bindPropertySanitizer(controller) {
    if (!controller.form) return;

    var sanitizeControls = function () {
      sanitizeMalformedPropertyControls(controller);
    };

    controller.form.addEventListener('submit', sanitizeControls, true);
    controller.form.addEventListener('formdata', sanitizeMalformedFormData);
    controller.addButton?.addEventListener('click', sanitizeControls, true);
    controller.buyNowButton?.addEventListener('click', sanitizeControls, true);
    sanitizeControls();
  }

  function getGroups(controller) {
    return Array.from(controller.gate.querySelectorAll('[data-sb-io-group]'));
  }

  function updateSelectedOptionText(group) {
    var selectedText = group.querySelector('[data-sb-io-selected]');
    if (!selectedText) return;

    var selected = group.querySelector('[data-sb-io-swatch][aria-checked="true"]');
    if (!selected) {
      selectedText.textContent = 'Please select';
      return;
    }

    var value = selected.dataset.optionValue || '';
    var soldOutText = selected.dataset.soldOut === 'true' ? ' (Sold out)' : '';
    selectedText.textContent = (value || 'Please select') + soldOutText;
  }

  function setSwatchSoldOutState(group, button, source, soldOut) {
    button.dataset[source + 'SoldOut'] = String(soldOut);

    var isSoldOut =
      button.dataset.appSoldOut === 'true' ||
      button.dataset.productSoldOut === 'true';
    var optionValue = button.dataset.optionValue || '';

    button.dataset.soldOut = String(isSoldOut);
    button.disabled = false;
    button.setAttribute('aria-disabled', 'false');
    button.setAttribute(
      'aria-label',
      optionValue + (isSoldOut ? ', Sold out' : '')
    );
    button.title = optionValue + (isSoldOut ? ' (Sold out)' : '');

    if (button.getAttribute('aria-checked') === 'true') {
      updateSelectedOptionText(group);
    }
  }

  function updateButtonState(controller) {
    var groups = getGroups(controller);
    var allSelected =
      groups.length > 0 &&
      groups.every(function (group) {
        var input = group.querySelector('[data-sb-io-prop]');
        var selected = group.querySelector('[data-sb-io-swatch][aria-checked="true"]');
        return Boolean(input?.value && selected);
      });
    var hasSoldOutSelection = groups.some(function (group) {
      var selected = group.querySelector('[data-sb-io-swatch][aria-checked="true"]');
      return selected?.dataset.soldOut === 'true';
    });

    controller.gate.classList.toggle('is-complete', allSelected);

    [controller.addButton, controller.buyNowButton].forEach(function (button) {
      if (!button) return;

      var parentAvailable = button.dataset.bundleParentAvailable === 'true';
      var enabled = allSelected && !hasSoldOutSelection && parentAvailable;

      if (button.disabled === enabled) button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
    });
  }

  function selectSwatch(controller, group, button) {
    group.querySelectorAll('[data-sb-io-swatch]').forEach(function (swatch) {
      swatch.setAttribute('aria-checked', String(swatch === button));
    });

    var value = button.dataset.optionValue || '';
    var input = group.querySelector('[data-sb-io-prop]');

    if (input) input.value = value;
    updateSelectedOptionText(group);

    syncAppSelect(controller, group, value);
    updateBundleSelection(controller);
    updateButtonState(controller);
  }

  function applyAppAvailability(controller) {
    var appSelects = hideAppSelectors(controller);

    getGroups(controller).forEach(function (group, index) {
      var select = appSelects[index];
      if (!select) return;

      group.querySelectorAll('[data-sb-io-swatch]').forEach(function (button) {
        var matchingOption = Array.prototype.find.call(select.options || [], function (option) {
          return normalize(option.textContent) === normalize(button.dataset.optionValue);
        });

        if (matchingOption) {
          setSwatchSoldOutState(
            group,
            button,
            'app',
            Boolean(matchingOption.disabled)
          );
        }
      });
    });

    updateButtonState(controller);
  }

  function getSwatchColor(controller, normalizedValue) {
    var color = controller.shadeColors[normalizedValue] || '';
    if (!color) return '';

    if (window.CSS?.supports && !window.CSS.supports('color', color)) {
      return '';
    }

    return color;
  }

  function setSwatchPresentation(button, media, type, value) {
    if (!media) return;

    button.classList.remove(
      'sb-io-swatch--color',
      'sb-io-swatch--image',
      'sb-io-swatch--text'
    );
    button.classList.add('sb-io-swatch--' + type);
    media.style.removeProperty('background-color');

    if (type === 'color') {
      media.innerHTML = '';
      media.style.backgroundColor = value;
      return;
    }

    if (type === 'image') {
      media.innerHTML =
        '<img class="sb-io-swatch__image" src="' +
        escapeHtml(value) +
        '" alt="" loading="lazy">';
      return;
    }

    media.innerHTML =
      '<span class="sb-io-swatch__text">' +
      escapeHtml(value) +
      '</span>';
  }

  function setSwatchImage(button, media, imageUrl, optionValue) {
    setSwatchPresentation(button, media, 'image', imageUrl);

    var image = media?.querySelector('.sb-io-swatch__image');
    image?.addEventListener(
      'error',
      function () {
        setSwatchPresentation(button, media, 'text', optionValue);
      },
      { once: true }
    );
  }

  function decorateSwatch(controller, group, button, productMap) {
    var optionName = group.dataset.optionName || '';
    var optionValue = button.dataset.optionValue || '';
    var normalizedValue = normalize(optionValue);
    var record =
      productMap[normalize(optionName) + '::' + normalizedValue] ||
      productMap[normalizedValue];
    var media = button.querySelector('[data-sb-swatch-media]');
    var shadeColor = getSwatchColor(controller, normalizedValue);
    var fallbackImage = record?.image || '';

    if (shadeColor && media) {
      setSwatchPresentation(button, media, 'color', shadeColor);
    } else if (fallbackImage && media) {
      setSwatchImage(button, media, fallbackImage, optionValue);
    } else {
      setSwatchPresentation(button, media, 'text', optionValue);
    }

    if (!record?.handle) return;

    fetchProduct(record, controller.config.country).then(function (product) {
      if (!product || !button.isConnected) return;

      var available = getProductAvailability(product, record);
      setSwatchSoldOutState(group, button, 'product', !available);

      if (!shadeColor && media) {
        var imageUrl = getProductImage(product, record);
        if (imageUrl) {
          setSwatchImage(button, media, imageUrl, optionValue);
        } else {
          setSwatchPresentation(button, media, 'text', optionValue);
        }
      }

      updateButtonState(controller);
    });
  }

  function decorateSwatches(controller) {
    var productMap = buildProductMap(controller);

    getGroups(controller).forEach(function (group) {
      group.querySelectorAll('[data-sb-io-swatch]').forEach(function (button) {
        decorateSwatch(controller, group, button, productMap);
      });
    });
  }

  function bindSwatches(controller) {
    getGroups(controller).forEach(function (group) {
      group.querySelectorAll('[data-sb-io-swatch]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectSwatch(controller, group, button);
        });
      });
    });
  }

  function renderAddError(controller, response) {
    var errorContainer = controller.form?.querySelector('[data-cart-errors-container]');
    if (!errorContainer) return;

    var message =
      response?.description ||
      response?.message ||
      'Something went wrong. Please try again.';

    errorContainer.innerHTML =
      '<div class="errors">' + escapeHtml(message) + '</div>';
    errorContainer.classList.add('is-visible');
  }

  function bindAddToCart(controller) {
    if (!controller.addButton || !controller.form) return;

    controller.addButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (controller.addButton.disabled || controller.addRequestPending) return;

      if (!controller.form.checkValidity()) {
        controller.form.reportValidity();
        return;
      }

      sanitizeMalformedPropertyControls(controller);

      var formData = new FormData(controller.form);
      var quantity = formData.get('quantity') || '1';
      formData.delete('quantity');
      formData.append('quantity', quantity);

      var route = window.theme?.routes?.cart_add_url || '/cart/add.js';
      controller.addRequestPending = true;
      controller.addButton.disabled = true;
      controller.addButton.setAttribute('aria-disabled', 'true');
      controller.addButton.classList.add('is-loading');

      fetch(route, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw data;
            return data;
          });
        })
        .then(function (response) {
          controller.addButton.classList.add('is-added');
          controller.addButton.dispatchEvent(
            new CustomEvent('theme:product:add', {
              detail: {
                response: response,
                button: controller.addButton,
              },
              bubbles: true,
            })
          );
        })
        .catch(function (response) {
          renderAddError(controller, response);
          controller.addButton.dispatchEvent(
            new CustomEvent('theme:product:add-error', {
              detail: {
                response: response,
                button: controller.addButton,
              },
              bubbles: true,
            })
          );
        })
        .finally(function () {
          controller.addRequestPending = false;
          controller.addButton.classList.remove('is-loading');
          window.setTimeout(function () {
            controller.addButton.classList.remove('is-added');
          }, 1000);
          updateButtonState(controller);
        });
    });
  }

  function bindBuyNow(controller) {
    if (!controller.buyNowButton) return;

    controller.buyNowButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (controller.buyNowButton.disabled || !controller.addButton) return;

      controller.buyNowButton.disabled = true;
      var timeoutId;

      var cleanup = function () {
        document.removeEventListener('theme:product:add', handleSuccess);
        document.removeEventListener('theme:product:add-error', handleError);
        if (timeoutId) window.clearTimeout(timeoutId);
      };

      var matchesButton = function (addEvent) {
        return !addEvent.detail?.button || addEvent.detail.button === controller.addButton;
      };

      var handleSuccess = function (addEvent) {
        if (!matchesButton(addEvent)) return;
        cleanup();
        window.location.assign('/checkout');
      };

      var handleError = function (addEvent) {
        if (!matchesButton(addEvent)) return;
        cleanup();
        updateButtonState(controller);
      };

      document.addEventListener('theme:product:add', handleSuccess);
      document.addEventListener('theme:product:add-error', handleError);
      controller.addButton.click();

      timeoutId = window.setTimeout(function () {
        cleanup();
        updateButtonState(controller);
      }, 10000);
    });
  }

  function initGate(gate) {
    if (gate.dataset.sbGateInitialized === 'true') return;
    gate.dataset.sbGateInitialized = 'true';

    var configElement = gate.querySelector('[data-simple-bundles-config]');
    if (!configElement) return;

    var config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }

    var formId = gate.dataset.productFormId;
    var form = document.getElementById(formId);
    var controller = {
      gate: gate,
      config: config,
      form: form,
      section: gate.closest('[data-section-id]') || gate.closest('.shopify-section') || document,
      shadeColors: parseShadeColors(config.shadeColors),
      addButton: form?.querySelector('[data-bundle-add-to-cart]'),
      buyNowButton: form?.querySelector('[data-bundle-buy-now]'),
      bundleSelectionInput: gate.querySelector('[data-sb-io-bundle-selection]'),
      appSelects: [],
      addRequestPending: false,
    };

    bindSwatches(controller);
    bindAddToCart(controller);
    bindBuyNow(controller);
    bindPropertySanitizer(controller);
    decorateSwatches(controller);
    updateBundleSelection(controller);
    updateButtonState(controller);

    var scheduled = false;
    controller.observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;
        applyAppAvailability(controller);
      });
    });

    controller.observer.observe(controller.section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });

    applyAppAvailability(controller);
  }

  function init() {
    document.querySelectorAll('[data-simple-bundles-swatches]').forEach(initGate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
